__turbopack_context__.v({
  "closeBtn": "PdfViewerButton-module-scss-module__3tRY9G__closeBtn",
  "modal": "PdfViewerButton-module-scss-module__3tRY9G__modal",
  "overlay": "PdfViewerButton-module-scss-module__3tRY9G__overlay",
});
